// removed by extract-text-webpack-plugin
module.exports = {"item-short-header":"main_nav-2b9","item":"main_nav-2xY","item-header-link":"main_nav-36w","item-header-text":"main_nav-Ym0","active":"main_nav-3jp","tablet-no-pointer":"main_nav-1Cd","item-more-link":"main_nav-1HU","item-long-header":"main_nav-184"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/Submenu/SubmenuItem/submenu_item.module.scss
// module id = 360
// module chunks = 0